@if (isCompareMode) {
  <div
    class="comment-annotation-component d-flex flex-column h-100 min-h-0"
    [class.private]="privateCondition !== null">
    <!-- Conversation / plugin UI is composed by the parent (e.g. conversation-interface); this host reserves layout. -->
    <div class="comment-annotation-main flex-fill min-h-0"></div>
    <div class="control-bar d-flex align-items-center justify-content-end pe-3 ps-2 py-2 mt-1">
      <div class="d-flex align-items-center control-bar-right">
        <viewer-reject-button></viewer-reject-button>
        <viewer-approve-button></viewer-approve-button>
        <viewer-compare-button
          [projectId]="projectId || item?.projectId"
          [sectionId]="sectionId || item?.sectionId"
          [subsectionId]="subsectionId || item?.subSectionId"
          [optionId]="typeId || item?.optionId || item?.itemId"
          [versionNumber]="item?.versionNumber"
          [fileId]="item?.id"></viewer-compare-button>
        <mtm-file-download-control
          [file]="item"
          displayType="icon"
          #downloadButton
          [iconSize]="18"
          [lightIcon]="true"
          [iconColor]="'#b0b0b0'"
          [uniqueControlId]="item ? `${item.projectId}-${item.sectionId}-${item.subSectionId}-${item.id}` : instanceId">
        </mtm-file-download-control>
        <viewer-info-button [file]="item"></viewer-info-button>
        <viewer-cinema-mode-button class="zoom-chevron"></viewer-cinema-mode-button>
        <!-- <viewer-fullscreen-button
          [active]="isFullscreen"
          (clicked)="toggleFullscreenForViewer()"></viewer-fullscreen-button> -->
      </div>
    </div>
  </div>
}
